var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTavily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d0348dc115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.378906 231.132812 L 146.484375 231.132812 L 146.484375 268.238281 L 109.378906 268.238281 Z M 109.378906 231.132812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a28b194a7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127.933594 231.132812 C 117.6875 231.132812 109.378906 239.4375 109.378906 249.6875 C 109.378906 259.933594 117.6875 268.238281 127.933594 268.238281 C 138.179688 268.238281 146.484375 259.933594 146.484375 249.6875 C 146.484375 239.4375 138.179688 231.132812 127.933594 231.132812 Z M 127.933594 231.132812 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0, -2.578223, 2.578223, 0, 113.745458, 254.140061)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 5.499573 5.500038 L 79.114962 5.500038 ",
    stroke: "#f25022",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0, -2.578223, 2.578223, 0, 113.745458, 254.140061)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 59.865692 -10.999336 L 81.864858 5.500038 L 59.865692 21.999412 ",
    stroke: "#f25022",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.578223, -0.000251357, 0.000251357, 2.578223, 126.828174, 239.987372)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 5.500751 5.50068 L 72.398214 5.499627 ",
    stroke: "#ffb901",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.578223, -0.000251357, 0.000251357, 2.578223, 126.828174, 239.987372)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 53.149037 -11.000109 L 75.148109 5.499895 L 53.14885 22.000154 ",
    stroke: "#ffb901",
    strokeWidth: 11,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-1.692446, 1.944957, -1.944957, -1.692446, 134.219043, 258.208373)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 4.499518 4.49999 L 38.441562 4.500107 ",
    stroke: "#04a3ec",
    strokeWidth: 9,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-1.692446, 1.944957, -1.944957, -1.692446, 134.219043, 258.208373)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 22.691248 -9.000192 L 40.69038 4.49943 L 22.68978 17.999994 ",
    stroke: "#04a3ec",
    strokeWidth: 9,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d0348dc115)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a28b194a7a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32b37f",
    d: "M 109.378906 231.132812 L 146.484375 231.132812 L 146.484375 268.238281 L 109.378906 268.238281 Z M 109.378906 231.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTavily);
export default __webpack_public_path__ + "static/media/tavily.983e12aa803a4c4e263d996b78698e5d.svg";
export { ForwardRef as ReactComponent };